import PublicApp from './PublicApp';
import { getPublicPurchaseMotionsByLocation } from 'pricing-pages-lib/api/PurchaseMotionsApi';
import { CALCULATOR, MERCH_CARD } from 'pricing-pages-lib/constants/PurchaseMotionsLocations';
import _PublicUsageTracker from 'pricing-pages-ui/utils/tracking/_PublicUsageTracker';
import { PUBLIC } from './constants/AuthType';
import { getPublicPagePath } from './utils/urls/publicUtils';
const publicConfig = {
  authType: PUBLIC,
  rootUrl: getPublicPagePath(),
  tracker: _PublicUsageTracker(),
  blockingRequests: [
    //   fetchPublicExperimentTreatmentsFromEarlyRequest,
  ],
  defaultHubRoute: '/marketing',
  getPurchaseMotions: () => {
    const navigator = window.navigator;
    let preferredLanguage = navigator.languages || navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage;
    if (preferredLanguage && preferredLanguage.length) {
      if (Array.isArray(preferredLanguage)) {
        // This is simpler than the existing dot com logic
        // but I think this is sufficient since the fallbacks
        // aren't very important
        // See: https://codepen.io/anythingcodes/pen/XwdzYW?editors=0010
        preferredLanguage = preferredLanguage[0];
      }
    }
    return getPublicPurchaseMotionsByLocation([MERCH_CARD, CALCULATOR], preferredLanguage && preferredLanguage.toLowerCase());
  }
};
new PublicApp(publicConfig).start();